import { render } from "./RssModal.vue?vue&type=template&id=87bc09fa&scoped=true"
import script from "./RssModal.vue?vue&type=script&lang=js"
export * from "./RssModal.vue?vue&type=script&lang=js"

import "./RssModal.vue?vue&type=style&index=0&id=87bc09fa&scoped=true&lang=css"
import "./RssModal.vue?vue&type=style&index=1&id=87bc09fa&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87bc09fa"]])

export default __exports__